import { withJob } from 'react-jobs'
import loadTheme from './loader'

export function work(props) {
  return loadTheme(props.theme)
}

export default withJob({
  work
})
